export type UiErrorSource =
  | 'ui.syncEngine.flush'
  | 'ui.syncEngine.outbox.load'
  | 'ui.syncEngine.outbox.parse'
  | 'ui.syncEngine.startSession'
  | 'note-path.bootstrapPath'
  | 'note-path.loadProgress'
  | 'note-path.applyInitialPhase'
  | 'startQuiz'
  | 'startMode'
  | 'submitAnswer'
  | 'nextQuestion'
  | 'quiz.generateQuestion'
  | 'feedback.submit'
  | 'fretboard.onRehydrateStorage'
  | 'fretboard.config.missingInstrumentDefaults'
  | 'fretboard.config.invalidTuning'
  | 'scaleDisplay.currentScaleNotes'
  | 'scaleDisplay.standardizedDegree'
  | 'theme.onRehydrateStorage';

export function reportUiError(
  reportErrorFn: (error: unknown, context?: Record<string, unknown>) => void,
  source: UiErrorSource,
  error: unknown,
  context?: Record<string, unknown>
): void {
  reportErrorFn(error, { source, ...(context ?? {}) });
}
